import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	label: {
		alignItems: 'center',
		height: 42,
		flex: 1,
		flexDirection: 'row',
		paddingBottom: 10,
		paddingRight: 10,
	},

	labelText: {
		color: '$colorBrandQuaternary',
		fontSize: 16,
	},
});
